import { Accordion } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../store";

function Menu() {
  const {
    language: activeLanguage,
    automation: activeAutomation,
    event: activeEvent,
    action: activeAction,
    target: activeTarget,
  } = useParams();
  const navigate = useNavigate();

  const activeCompany = useAppSelector((state) => state.company.activeCompany);

  const blocksAndTemplates = useAppSelector((state) => state.company.blocksAndTemplates);
  const templateSummary = useAppSelector((state) => state.company.templateSummary);

  return (
    <Accordion key={activeAutomation} activeKey={activeAutomation}>
      {Object.keys(blocksAndTemplates).map((automation: string) => {
        const events = blocksAndTemplates[automation as keyof typeof blocksAndTemplates];
        return (
          <Accordion.Item eventKey={automation} key={automation}>
            <Accordion.Header
              onClick={() => {
                if (activeAutomation === automation) navigate(`/mail-templates/${activeLanguage}`);
                else navigate(`/mail-templates/${activeLanguage}/${automation}`);
              }}
            >
              <span style={{ fontSize: "12px" }}>{automation}</span>
            </Accordion.Header>
            <Accordion.Body className="p-0 ps-3">
              <Accordion key={activeEvent} activeKey={activeEvent}>
                {Object.keys(events).map((event: string) => {
                  const actions: any = events[event as keyof typeof events];
                  if (
                    activeCompany?.name != "vastgoedpartners" &&
                    (event.includes("VISIT_GENERIC_HUURCONTRACT") || event.includes("VISIT_GENERIC_COMPROMIS"))
                  ) {
                    // We do not want to show these events for companies other than Vastgoedpartners
                    return;
                  }
                  return (
                    <Accordion.Item eventKey={event} key={event}>
                      <Accordion.Header
                        onClick={() => {
                          if (activeEvent === event) navigate(`/mail-templates/${activeLanguage}/${automation}`);
                          else navigate(`/mail-templates/${activeLanguage}/${automation}/${event}`);
                        }}
                      >
                        <span style={{ fontSize: "12px" }}>{event}</span>
                      </Accordion.Header>
                      <Accordion.Body className="p-0 ps-3">
                        <Accordion key={activeAction} activeKey={activeAction}>
                          {Object.keys(actions).map((action: string) => {
                            const targets: any = actions[action as keyof typeof actions];
                            return (
                              <Accordion.Item eventKey={action} key={action}>
                                <Accordion.Header
                                  onClick={() => {
                                    if (activeEvent === event && activeAction === action)
                                      navigate(`/mail-templates/${activeLanguage}/${automation}/${event}`);
                                    else navigate(`/mail-templates/${activeLanguage}/${automation}/${event}/${action}`);
                                  }}
                                >
                                  <span style={{ fontSize: "12px" }}>{action}</span>
                                </Accordion.Header>
                                <Accordion.Body className="p-0 ps-3">
                                  <Accordion key={activeTarget} activeKey={activeTarget}>
                                    {targets.map((target: string) => {
                                      const templatesMaintained = templateSummary.maintained.filter(
                                        (ts: any) => ts.event == event && ts.action == action && ts.target == target,
                                      );

                                      let check = "";
                                      let fill = "";
                                      if (
                                        templatesMaintained &&
                                        templatesMaintained.find((ts: any) => ts.version === "live")
                                      ) {
                                        check = "-check";
                                      }
                                      if (
                                        templatesMaintained &&
                                        templatesMaintained.find((ts: any) => ts.version === "draft")
                                      ) {
                                        fill = "-fill";
                                      }

                                      const templateActiveColor =
                                        templateSummary.config.filter(
                                          (ts: any) =>
                                            ts.active &&
                                            ts.event == event &&
                                            ts.action == action &&
                                            ts.target == target,
                                        ).length > 0
                                          ? "#7dee5d"
                                          : "#FF0000";

                                      return (
                                        <Accordion.Item eventKey={target} key={target}>
                                          <Accordion.Header
                                            onClick={() => {
                                              if (
                                                activeEvent === event &&
                                                activeAction === action &&
                                                activeTarget === target
                                              )
                                                navigate(
                                                  `/mail-templates/${activeLanguage}/${automation}/${event}/${action}`,
                                                );
                                              else {
                                                navigate(
                                                  `/mail-templates/${activeLanguage}/${automation}/${event}/${action}/${target}/draft`,
                                                );
                                              }
                                            }}
                                          >
                                            <span style={{ fontSize: "12px" }}>{target}</span>
                                            {event !== "replacements" && (
                                              <i
                                                className="ps-1 bi bi-circle-fill"
                                                style={{ color: templateActiveColor }}
                                              ></i>
                                            )}
                                            {(check !== "" || fill !== "") && (
                                              <i className={`ps-1 bi bi-clipboard${check}${fill}`}></i>
                                            )}
                                          </Accordion.Header>
                                        </Accordion.Item>
                                      );
                                    })}
                                  </Accordion>
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
}

export default Menu;
